import type { App } from 'vue';
import Timeline from './src/timeline.vue';
export declare const ToTimeline: any;
export type TimelineInstance = InstanceType<typeof Timeline>;
declare const _default: {
    install(app: App): void;
};
export default _default;
export * from './src/timeline';
